// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"7947333b","587":"7a239855"}[chunkId] + ".chunk.css";
};